import React, { ReactElement } from 'react';
import classNames from 'classnames';
import Field, { FieldProps } from './Field';

export interface FieldGroupProps {
  children: ReactElement<FieldProps> | ReactElement<FieldProps>[];
  className?: string;
  id?: string;
}

const FieldGroup = ({ children, className, id }: FieldGroupProps): JSX.Element => (
  <dl id={id} className={classNames('ver-field-group', className)}>
    {children}
  </dl>
);

FieldGroup.Field = Field;

export default FieldGroup;
